
import { useState, useEffect } from 'react';

const TIMER_STORAGE_KEY = "specialDealTimerEnd";
const TIMER_EXPIRED_KEY = "specialDealExpired";
const TIMER_INITIAL_VALUE = 3 * 60; // 3 minutes in seconds

export const useTimerExpiration = () => {
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    // Check if timer has already been marked as expired
    const expired = localStorage.getItem(TIMER_EXPIRED_KEY) === "true";
    
    if (expired) {
      setIsExpired(true);
      return;
    }

    // Check timer end time
    const timerEndStr = localStorage.getItem(TIMER_STORAGE_KEY);
    if (timerEndStr) {
      const timerEnd = parseInt(timerEndStr, 10);
      const now = Date.now();
      
      // If timer has expired
      if (timerEnd <= now) {
        localStorage.setItem(TIMER_EXPIRED_KEY, "true");
        setIsExpired(true);
      } else {
        // Set up check for when timer will expire
        const timeRemaining = timerEnd - now;
        const timeout = setTimeout(() => {
          localStorage.setItem(TIMER_EXPIRED_KEY, "true");
          setIsExpired(true);
        }, timeRemaining);
        
        return () => clearTimeout(timeout);
      }
    } else {
      // No timer has been set yet, not expired
      setIsExpired(false);
    }
  }, []);

  return { isExpired };
};

export default useTimerExpiration;
